import "@/sentry"; // Must be the very first import so global handlers attach early.
import "@/i18n";   // Bootstrap i18next before any component renders translated strings.
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerAppServiceWorker } from "@/lib/sw-register";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the offline-shell + push service worker (production only).
registerAppServiceWorker();
